import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import Moment from 'moment';
import { withStyles } from '@mui/styles';
import { getConnections } from './ConnectorService';
import { MultiSelect } from '../../components/Selects';
import { PubSub } from '../../utils/eventUtils';
import { ConnectorDetails } from './ConnectorDetails';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import { UrlDateRangePicker } from '../../components/inputs/DateRangePicker';
import withRouter from '../../components/hocs/withRouter';
import { withBackfill } from '../../components/hocs/withBackfill';

const styles = ({ palette }: any) => ({
  headerNav: {
    fontSize: '0.67rem',
    lineHeight: 1.5,
    color: palette.primary.main,
    textAlign: 'left',
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dropdown: {
    margin: '0.3rem 0 0 2rem',
    width: '25rem',
  },
  button: {
    padding: '5px !important',
    border: `1px solid ${palette.primary.oldBorder2}`,
    height: '2.5rem',
  },
  headerDateRangeComboContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
});

// ui
const ConnectorDetailsContainer = ({ classes, ...props }: any) => {
  const pathname = props.location.pathname.replace(
    '/customer/connector/connector-details/',
    ''
  );
  const parts = pathname.split('/');
  const connectorType = parts[0];
  const [myData, setMyData] = useState(null);
  const [myOption, setMyOption] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState(null);
  const shareData = {
    microsoft: {
      title: 'Microsoft Secure Score',
      name: 'Microsoft Secure Score',
    },
    google: {
      title: 'Google Command Center',
      name: 'Google Command Center',
    },
    securitystudio: {
      title: 'Security Studio',
      name: 'Security Studio',
    },
  };

  useEffect(() => {
    Promise.all([getConnections()])
      .then((responses) => {
        const data = responses[0].data.content;
        const connectors = Array.isArray(data)
          ? data.filter(
              (item) => item.connectorType.toLowerCase() === connectorType
            )
          : [];
        setMyOption({
          label:
            connectorType === 'microsoft'
              ? connectors[0].metadata.azureTenantDisplayName ?? ''
              : connectors[0].metadata.organizationId,
          value: connectors[0].id,
        });

        setDropdownOptions(
          connectors.map((item) => ({
            label:
              connectorType === 'microsoft'
                ? item.metadata.azureTenantDisplayName
                : item.metadata.organizationId,
            value: item.id,
          }))
        );

        setMyData({ connectors });
      })
      .catch(console.error.bind(console));
  }, [connectorType, props.q]);

  const selectHandler = (name: any, value: any) => {
    PubSub.publish('ConnectorDetailsContainer:render', value.value);
    setMyOption(value);
  };

  const renderHeaderNav = () => {
    return (
      <section className={classes.headerNav}>
        <section className={classes.breadcrumbs}>
          <Breadcrumbs title={shareData[connectorType].title}>
            <Link to="/customer/connectors">Connectors</Link>
            <p>{shareData[connectorType].name}</p>
          </Breadcrumbs>
        </section>
        <section className={classes.headerDateRangeComboContainer}>
          <section style={{ height: '2.5rem', marginTop: '0.3rem' }}>
            <UrlDateRangePicker
              key={props.location.search}
              maxDate={new Date()}
              inlineLabel
            />
          </section>
          {connectorType !== 'SECURITYSTUDIO' && (
            <section className={classes.dropdown}>
              <MultiSelect
                name="days"
                isMulti={false}
                options={dropdownOptions}
                onChange={selectHandler}
                values={myOption}
                required
                classes={{
                  select: classes.button,
                }}
              />
            </section>
          )}
        </section>
      </section>
    );
  };

  if (myData) {
    return (
      <section className={classes.mainContainer}>
        {renderHeaderNav()}
        <ConnectorDetails connectorId={myOption.value} q={props.q} />
      </section>
    );
  }
  return null;
};

export default compose(
  withRouter,
  withBackfill('UiSettings.dashboard', {
    size: 25,
    before: Moment().unix(),
    after: Moment().subtract(1, 'week').unix(),
  }),
  // @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { headerNa... Remove this comment to see the full error message
  withStyles(styles, { withTheme: true })
)(ConnectorDetailsContainer);
